import { createConfigurationInstance } from "../config";
import { createAuthInstance } from "../auth";
import { createLocaleInstance } from "../locale";
import { CreateOrganizationManager } from "../config/OrganizationManager";
import { addRenewTokenMethodToAxiosInstance, applyAuthenticationInterceptor, createRestClientInstance, } from "../api";
import { handleGetRegistrationStep } from "../registration-step";
import { NOT_AUTH_PAGES } from "../constants/routes.constants";
export async function bootstrap() {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    const initialRest = createRestClientInstance({ baseURL: null });
    const configuration = await createConfigurationInstance(initialRest);
    const auth = createAuthInstance(configuration.auth, initialRest);
    const locale = createLocaleInstance();
    const orgManager = CreateOrganizationManager();
    const retrieveInfo = {};
    if (!NOT_AUTH_PAGES.includes(location.pathname)) {
        await auth.start();
    }
    const rest = createRestClientInstance(configuration.rest);
    if (!NOT_AUTH_PAGES.includes(location.pathname)) {
        applyAuthenticationInterceptor(rest, auth);
    }
    if (!NOT_AUTH_PAGES.some((path) => window.location.pathname.includes(path))) {
        const response = await handleGetRegistrationStep(rest);
        if (response)
            Object.assign(retrieveInfo, response);
    }
    addRenewTokenMethodToAxiosInstance(rest, auth);
    const context = Object.freeze({
        configuration,
        auth,
        rest,
        locale,
        orgManager,
        retrieveInfo,
    });
    Object.assign(window, { $platform: context });
    return context;
}
